import { render, staticRenderFns } from "./MetalTextCommemorativeDoorplate.vue?vue&type=template&id=7a03de44&scoped=true"
import script from "./MetalTextCommemorativeDoorplate.vue?vue&type=script&lang=js"
export * from "./MetalTextCommemorativeDoorplate.vue?vue&type=script&lang=js"
import style0 from "./MetalTextCommemorativeDoorplate.vue?vue&type=style&index=0&id=7a03de44&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a03de44",
  null
  
)

export default component.exports